/* Add to cart untuk semua kartu produk (.mpc) — dipakai homepage, related article,
   dan slider Recommended/Recently viewed. Satu delegated listener, jadi kartu yang
   disisipkan belakangan (Recently viewed) tetap jalan.

   Kalau section-nya merender snippets/museo-atc-feedback (window.MuseoATC), tombol
   memakai spinner + label "Added"; kalau tidak, cukup class .loading seperti sebelumnya. */

(function () {
  function sectionsToRender() {
    return [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
  }

  function sectionHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  function openDrawer(parsed) {
    sectionsToRender().forEach(function (sec) {
      var host = document.getElementById(sec.id);
      if (!host || !parsed.sections[sec.section]) return;
      var target = host.querySelector(sec.selector) || host;
      target.innerHTML = sectionHTML(parsed.sections[sec.section], sec.selector);
    });
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer) {
      // Reformation 17: panel tertutup diberi inert; OverlayManager.open melepasnya.
      if (typeof OverlayManager !== 'undefined') OverlayManager.open(drawer);
      else { drawer.classList.add('active'); drawer.inert = false; document.body.classList.add('open-cc'); }
      document.body.classList.add('open-cart');
    }
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('cart-drawer:open');
      dispatchCustomEvent('cart:item-added', { product: parsed.items ? parsed.items[0] : parsed });
    }
  }

  function prepare(root) {
    if (!window.MuseoATC) return;
    (root || document).querySelectorAll('[data-product-card-atc]').forEach(function (btn) {
      MuseoATC.prepare(btn);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-product-card-atc]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var feedback = window.MuseoATC && btn.classList.contains('matc');
    if (feedback) {
      if (!MuseoATC.start(btn)) return;
    } else {
      btn.classList.add('loading');
    }

    var fd = new FormData();
    fd.append('id', btn.getAttribute('data-product-card-atc'));
    fd.append('quantity', 1);
    fd.append('sections', sectionsToRender().map(function (x) { return x.section; }));
    fd.append('sections_url', window.location.pathname);

    var cartUrl = window.theme && window.theme.routes ? window.theme.routes.cart_add_url : '/cart/add.js';
    fetch(cartUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (feedback) MuseoATC.finish(btn, res.description || res.message || true);
          else btn.classList.remove('loading');
          return;
        }
        if (feedback) MuseoATC.finish(btn);
        else btn.classList.remove('loading');
        if (document.getElementById('Cart-Drawer')) {
          openDrawer(res);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        console.error(err);
        if (feedback) MuseoATC.finish(btn, true);
        else btn.classList.remove('loading');
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { prepare(); });
  } else {
    prepare();
  }

  window.MuseoProductCard = { prepare: prepare };
})();
